import React from 'react'
import {DevicesInfo} from "../../../widgets/devicesInfo";

const DevicesInfoPage = () => {
    return <DevicesInfo />
}

export default DevicesInfoPage
